module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idPan"
  }, [_c('div', {
    ref: "idListPan",
    staticStyle: {
      "float": "left",
      "width": "98%",
      "margin-left": "1%",
      "height": "550px",
      "padding-bottom": "10px",
      "border": "1px solid #bbbbbb",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.detList), function(curItem, index) {
    return _c('div', {
      staticClass: "DetPan",
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "index": index
      }
    }, [_c('div', {
      staticClass: "Cont",
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v(_vm._s(_vm.getLangText("订单号") + ": " + curItem.caiLocalOrderno))]), _vm._v(" "), _c('div', {
      staticClass: "Cont",
      staticStyle: {
        "width": "36%"
      }
    }, [_vm._v(_vm._s(_vm.getLangText("时间") + ": " + curItem.caiLocalDt))]), _vm._v(" "), _c('div', {
      staticClass: "Cont",
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v(_vm._s(_vm.getLangText("类型") + ": " + curItem.caiType_name))]), _vm._v(" "), _c('div', {
      staticClass: "Cont",
      staticStyle: {
        "width": "36%"
      }
    }, [_vm._v(_vm._s(_vm.getLangText("状态") + ": " + curItem.caiResult_name))]), _vm._v(" "), (_vm.img1Flag) ? _c('img', {
      staticClass: "CImg",
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "src": curItem.caiImg1
      }
    }) : _vm._e(), _vm._v(" "), (_vm.img2Flag) ? _c('img', {
      staticClass: "CImg",
      staticStyle: {
        "margin-left": "40px"
      },
      attrs: {
        "src": curItem.caiImg2
      }
    }) : _vm._e(), _vm._v(" "), (_vm.img5Flag) ? _c('img', {
      staticClass: "CImg",
      staticStyle: {
        "margin-left": "40px"
      },
      attrs: {
        "src": curItem.caiImg5
      }
    }) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1efa2164","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/aiDetail.vue
// module id = 770
// module chunks = 1